import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconChartBars32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconChartBars32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M23 21a1 1 0 1 0 2 0V6a1 1 0 1 0-2 0zm-7 1a1 1 0 0 1-1-1v-9a1 1 0 1 1 2 0v9a1 1 0 0 1-1 1m-9-1a1 1 0 1 0 2 0v-4a1 1 0 1 0-2 0zm-2 3a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2zm15-2a1 1 0 0 1-1-1v-7a1 1 0 1 1 2 0v7a1 1 0 0 1-1 1m-9-1a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconChartBars32);
